import { fetchJson } from '@shared/api';
import type {
  EditionSummaryResponse,
  EditionSourcesResponse,
  EditionScoringResponse,
  EditionClustersResponse,
  EditionRunsResponse,
} from '../types';

export const editionApi = {
  /**
   * Get latest edition summary (lightweight - initial load)
   */
  async getEditionSummary(): Promise<EditionSummaryResponse> {
    return fetchJson<EditionSummaryResponse>('/api/editions/latest');
  },

  /**
   * Get specific edition summary by date and edition
   */
  async getEditionSummaryByDate(date: string, edition: string): Promise<EditionSummaryResponse> {
    return fetchJson<EditionSummaryResponse>(`/api/editions/${date}/${edition}`);
  },

  /**
   * Get edition sources (source weights by category)
   */
  async getEditionSources(date: string, edition: string): Promise<EditionSourcesResponse> {
    return fetchJson<EditionSourcesResponse>(`/api/editions/${date}/${edition}/sources`);
  },

  /**
   * Get edition scoring (top scored items and statistics)
   */
  async getEditionScoring(date: string, edition: string): Promise<EditionScoringResponse> {
    return fetchJson<EditionScoringResponse>(`/api/editions/${date}/${edition}/scoring`);
  },

  /**
   * Get edition clusters (heavy payload - load on demand)
   */
  async getEditionClusters(date: string, edition: string): Promise<EditionClustersResponse> {
    return fetchJson<EditionClustersResponse>(`/api/editions/${date}/${edition}/clusters`);
  },

  /**
   * Get edition pipeline runs (execution history)
   */
  async getEditionRuns(date: string, edition: string): Promise<EditionRunsResponse> {
    return fetchJson<EditionRunsResponse>(`/api/editions/${date}/${edition}/runs`);
  },
};
